import { useEffect, useState } from 'react';

function TermsNavList() {
  const [path, setPath] = useState('');

  const itemClass =
    'text-defaultDark p-4 bg-whiteSubtle hover:text-default hover:bg-secondary cursor-pointer transition-all duration-300';

  const activeItemClass = 'text-default bg-secondary p-4';

  useEffect(() => {
    if (window) {
      setPath(window.location.pathname);
    }
  }, []);

  return (
    <div className="w-[60%] lg:w-auto flex flex-col gap-2">
      <div
        className={`${path === '/faq' ? activeItemClass : itemClass}`}
        onClick={() => window.location.assign('/faq')}
      >
        FAQ
      </div>
      <div
        className={`${path === '/rodo' ? activeItemClass : itemClass}`}
        onClick={() => window.location.assign('/rodo')}
      >
        RODO
      </div>
      <div
        className={`${path === '/privacy' ? activeItemClass : itemClass}`}
        onClick={() => window.location.assign('/privacy')}
      >
        Polityka prywatności
      </div>
    </div>
  );
}

export default TermsNavList;
